export const bonuses = [
  {
    n: '01',
    title: 'Calculadora de Costos & Inflación ARS',
    desc: 'El error más caro de las tejedoras es poner precios "a ojo". Con esta planilla automatizada cargás el precio de tus hilos y materiales y te devuelve exactamente cuánto cobrar para ganar un 300% real. Considera inflación, Mercado Pago, envíos y packaging. Cada vez que suben los hilos, actualizás un número y ya sabés tu nuevo precio justo.',
    price: '$14.990',
  },
  {
    n: '02',
    title: 'Foto-Studio con Celular: Amigurumis que Entran por los Ojos',
    desc: 'La gente no compra muñecos, compra emoción. Aprendés a crear escenarios tipo Pinterest con luz natural y fondos baratos que ya tenés en casa, para que tus fotos parezcan de una revista de diseño. La diferencia entre "qué lindo" y "¿cuánto cuesta? lo quiero ya" está en la foto.',
    price: '$9.900',
  },
  {
    n: '03',
    title: 'Instagram Express: 30 Plantillas de Canva Listas',
    desc: 'No pierdas tiempo diseñando desde cero. 30 plantillas editables con estética artesanal premium: subís la foto de tu amigurumi y ya tenés historias y posts que generan consultas de precio en menos de 24 horas. Feed coherente, profesional y que vende desde el primer día.',
    price: '$7.900',
  },
  {
    n: '04',
    title: 'Tu Tienda Online en 24 Horas (Empretienda / Tiendanube)',
    desc: 'Cansate de gestionar pedidos por MD y que te dejen en visto. Una guía paso a paso para configurar tu propia tienda, cobrar con Mercado Pago y gestionar envíos a todo el país mientras seguís tejiendo. Tu negocio abierto las 24 horas sin que tengas que estar presente.',
    price: '$7.900',
  },
  {
    n: '05',
    title: 'Diccionario Maestro de Patrones (Español · Inglés · Portugués)',
    desc: 'Encontrás el patrón de tus sueños pero está en inglés o en términos que no entendés. Con este glosario técnico desbloqueás el acceso a miles de patrones internacionales y te ponés un paso adelante con diseños únicos que nadie más tiene en Argentina.',
    price: '$5.900',
  },
];
